import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { selectCurrentUser } from '../store/slices/authSlice';
import { getReturnUrl, clearLoggingOut } from '../util/returnUrl';
import { openSessionExpiredDialog } from '../store/slices/applicationSlice';
import { openMessage } from '../store/slices/showMessageSlice';
import Login from '../pages/login/Login';

/**
 * Route-level guard for the login page.
 * If the user already has a token (no 401 / session not cleared), redirect to home or returnUrl
 * so they are not shown the login screen (e.g. when using the browser back button).
 */
const LoginRouteGuard = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const sessionExpiredDialog = useSelector((state) => state.application.sessionExpiredDialog);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    clearLoggingOut();
    if (sessionExpiredDialog) {
      dispatch(
        openMessage({
          message: 'Your session has expired. Please log in again.',
          messageSeverity: 'warning',
        })
      );
      dispatch(openSessionExpiredDialog(false));
    }
  }, [dispatch, sessionExpiredDialog]);

  if (user) {
    const returnUrl = getReturnUrl(location, searchParams);
    return <Navigate to={returnUrl || '/'} replace />;
  }

  return <Login />;
};

export default LoginRouteGuard;
